import { GoogleChromeIcon } from './GoogleChromeIcon';

/**
 * author: Google
 * id 0B7D7D86-21E1-4759-8E4D-5D2BB291BB3F
 * name google-chrome
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-chrome.svg
 * tags
 * - Brand / Logo 
 */
export const ChromecastIcon = GoogleChromeIcon;
export default ChromecastIcon